import React, { Component }  from 'react';
import ReactPaginate from 'react-paginate';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Modal from '../../../../../components/Modal';
import Alert from '../../../../../components/Alert';
import { fetchFacturacion, fetchClientes, fetchFichaVenta, fetchClientesPedidos, fetchEditarFacturacion, fetchProformas } from '../../../../../actions';
import getPedidosFechas from '../../../../../utils/getPedidosFechas';
import _ from 'lodash';

const TIPO_CONSULTA_AGRUPADO_X_FACTURACION_CLIENTE='2';
const TIPO_CONSULTA_AGRUPADO_X_FACTURACION_MULTIPLE='1';
const TIPO_CONSULTA_AGRUPADO_X_FACTURACION_LISTADO_TOTAL='0';
const SIN_PAGINACION='N';
const CON_PAGINACION='N';
const PAGINA='1';
const NUMERO_PAGINAS='10';
const VACIO='';
const CONSULTA_CLIENTES='cadena'
const CONSULTA_TIPO='A'
const ESTADO_PEDIDO = 'ASIGNADO';

const CustomCheckbox = props => (
  <div className='checkbox'>
    <label >
      <input
        onClick={e => props.selectListPedDisponibles(e, props.cod, props.codFacturacion, props.tipo)} type='checkbox'
        checked={props.listPedidos.indexOf(props.cod) > -1}
      />
      <div className='checkbox-skin' />
      {props.name}
    </label>
  </div>
);

const renderTable = ({ data }, editarUsuPedido, idDiv, codUsuarioOld, collapse, opcionDivPedidoUsuario, checked, id) => {
  if (data.length) {
    return data.map(cliente => (
      <tr key={cliente.codigo} onClick={() => editarUsuPedido(cliente, codUsuarioOld, idDiv, collapse, opcionDivPedidoUsuario, checked, id)}>
        <td>{cliente.codigo}</td>
        <td>{cliente.nombre}</td>
        <td>{cliente.ruc}</td>
        <td>{cliente.dni}</td>
      </tr>
    ));
  }
  return <tr><td className='no-before' colSpan={5}>No hay resultados</td></tr>;
};

class EditarFacturacion extends Component {

  constructor(props) {
    super(props);
    this.state = {
      step: 1,
      muestraLoad:'none',
      listaMotivos:[],
      tipoMotivo:'',
      observacion:'',
      cantidadListadoFacturacion: '0',
      listCodFacturacion: [],
      listCodPropietario: [],
      listCodUsuario: [],
      pedClieCount: 0,
      pedPropCount: 0,
      pedFactCount: 0,
      facturacionListado:[],
      arrayLibresPedidos:[],
      arrayLibresPedidosPropietario:[],
      arrayLibresPedidosUsuario:[],
      alertErrorMessage:'',
      alertErrorOpenModFacturacion: false,
      searchOption: 'cadena',
      clientInput: '',
      disabledClientePropietario:true
    };
  }

  onChangeInput = e => this.setState({ [e.target.name]: e.target.value });

  componentDidMount(){

    this.fnListadoPedidosFacturacion(this.props.fdvID);

  }

  handlePageClick = ({ selected }) => {

    this.props.loading('block');
    this.props.fetchClientesPedidos(this.state.optionSearch, this.state.valueSerach, selected + 1)
          .then(() => {
            this.props.loading('');
            this.setState({ clientes: Object.assign({}, this.props.clientes) });
            this.setState({ muestraLoad: '' });
          }
      );
  }

  showAlert = (alertType) => {
    this.setState({ [alertType]: true });
    setTimeout(() => this.setState({ [alertType]: false }), 5000);
  }

  closeAlertErrorModFacturacion = () => this.setState({ alertErrorOpenModFacturacion: false });

  openAlertFacturacion = (data) => {
    if (data.estadoTrama === '0') {
      this.setState({ alertErrorMessage: data.mensaje });
      this.showAlert('alertErrorOpenModFacturacion');
    } else if (data.estadoTrama === '1') {
      this.setState({ alertSuccessMessage: data.mensaje });
      this.showAlert('alertErrorOpenModFacturacion');
    } else {
      this.setState({ alertErrorMessage: `Hubo un error con el servicio ${data.estadoTrama}` });
      this.showAlert('alertErrorOpenModFacturacion');
    }
  }

  editarPedidosFacturacion = () => {
    let condicionFacturacion = 0;
    let condicionPropietario = 0;
    let condicionClientes = 0;
    let count = 0;
    let condicion = 1;
    let condicion2 = 1;
    let condicion3 = 1;

    const listCodFacturacion = this.state.listCodFacturacion;
    const facturacionListado = this.state.facturacionListado;
    const listCodPropietario = this.state.listCodPropietario;
    const listCodUsuario = this.state.listCodUsuario;

    for (let i = 0; i < this.state.listCodFacturacion.length; i++) {
      if (this.state.listCodFacturacion[i].status !== -1 && this.state.listCodFacturacion[i].descripcion === '') {
        condicionFacturacion = -1;
      }
    }

    for (let i = 0; i < this.state.listCodPropietario.length; i++) {
      if (this.state.listCodPropietario[i].status !== -1 && this.state.listCodPropietario[i].descripcion === '') {
        condicionPropietario = -1;
      }
    }

    for (let i = 0; i < this.state.listCodUsuario.length; i++) {
      if (this.state.listCodUsuario[i].status !== -1 && this.state.listCodUsuario[i].descripcion === '') {
        condicionClientes = -1;
      }
    }

    listCodFacturacion.forEach((usuario) => {
      count = 0;
      if (usuario.id !== null && usuario.statusEliminado !== -1) {
        facturacionListado.forEach((pedido) => {
          if (usuario.id === pedido.codClie) {
            count++;
          }
        });
        if (count === 0) {
          condicion = 0;
        }
      }
    });


    listCodPropietario.forEach((usuario) => {
      count = 0;
      if (usuario.id !== null && usuario.statusEliminado !== -1) {
        facturacionListado.forEach((pedido) => {
          if (usuario.id === pedido.codPropietarioVeh) {
            count++;
          }
        });
        if (count === 0) {
          condicion2 = 0;
        }
      }
    });

    listCodUsuario.forEach((usuario) => {
      count = 0;
      if (usuario.id !== null && usuario.statusEliminado !== -1) {
        facturacionListado.forEach((pedido) => {
          if (usuario.id === pedido.codUsuarioVeh) {
            count++;
          }
        });
        if (count === 0) {
          condicion3 = 0;
        }
      }
    });


    if (condicionFacturacion !== -1 && condicionPropietario !== -1 && condicionClientes !== -1 && condicion === 1 && condicion2 === 1 && condicion3 === 1) {
      this.setState({ muestraLoad: 'block' });
      const { id } = this.props.match.params;
      const promises = [];
      this.props.loading('block');

      this.state.facturacionListado.map(
          Rows => (
            promises.push(
              this.props.fetchEditarFacturacion(
                id,
                Rows.numPedidoVeh, '',
                Rows.codClie===null?Rows.codClieBackup:Rows.codClie,
                Rows.codPropietarioVeh===null?Rows.codPropietarioVehBackup:Rows.codPropietarioVeh,
                Rows.codUsuarioVeh===null?Rows.codUsuarioVehBackup:Rows.codUsuarioVeh,

                Rows.desClie===null?Rows.desClieBackup:Rows.desClie,
                Rows.desPropietarioVeh===null?Rows.desPropietarioVehBackup:Rows.desPropietarioVeh,
                Rows.desUsuarioVeh===null?Rows.desUsuarioVehBackup:Rows.desUsuarioVeh
              )
        )));

      Promise.all(promises).then((result) => {
        this.props.closeModal();
        this.props.loading('');
        this.props.changeIndex(3);
      }).catch(error => console.log(error));

      this.setState({ facturacionListado: [],
        facturacionGrupo: [],
        cantidadListadoFacturacion: '0',
        listCodFacturacion: [],
        listCodPropietario: [],
        listCodUsuario: [],
        listClientes: [],
        clientInput: '',
        searchOption: 'cadena',
        varCheckDefault: [],
        arrayLibresPedidos: [],
        arrayLibresPedidosPropietario: [],
        arrayLibresPedidosUsuario: [],
        pedClieCount: 0,
        pedPropCount: 0,
        pedFactCount: 0 });
    } else {
      if (condicionFacturacion === -1) {
        this.openAlertFacturacion({mensaje:'Asigne un Usuario Facturacion o elimine los usuarios que no se utilicen.',estadoTrama:'0'})
      } else {
        if (condicionPropietario === -1) {
          this.openAlertFacturacion({mensaje:'Asigne un Usuario Propietario o elimine los usuarios que no se utilicen.',estadoTrama:'0'})
        } if (condicionClientes === -1) {
          this.openAlertFacturacion({mensaje:'Asigne un Usuario Vehiculo o elimine los usuarios que no se utilicen.',estadoTrama:'0'})
        } else if (condicion === 0) {
          this.openAlertFacturacion({mensaje:'Obligatoriamente debe asignar un pedido a un cliente facturacion.',estadoTrama:'0'})
        } else if (condicion2 === 0) {
          this.openAlertFacturacion({mensaje:'Obligatoriamente debe asignar un pedido a un cliente propietario.',estadoTrama:'0'})
        } else if (condicion3 === 0) {
          this.openAlertFacturacion({mensaje:'Obligatoriamente debe asignar un pedido a un cliente usuario.',estadoTrama:'0'})
        }
      }


      // alert("Valide si se asigno un usuario, propietario o propietario a facturar.");
    }
  }

  addPedidosfacturacionListado = (value, tipo) => {

    const facturacionListado = this.state.facturacionListado;
    switch (tipo) {
      case 1:
        for (let i = 0; i < this.state.facturacionListado.length; i++) {
          if (this.state.facturacionListado[i].numPedidoVeh === value) {
            facturacionListado[i].codClieBackup = facturacionListado[i].codClie;
            facturacionListado[i].desClieBackup = facturacionListado[i].desClie;
            facturacionListado[i].codClie = null;
            facturacionListado[i].desClie = null;
            this.setState({ facturacionListado });
            this.setState({ arrayLibresPedidos: [] });
          }
        }
        break;
      case 2:
        for (let i = 0; i < this.state.facturacionListado.length; i++) {
          if (this.state.facturacionListado[i].numPedidoVeh === value) {
            facturacionListado[i].codPropietarioVehBackup = facturacionListado[i].codPropietarioVeh;
            facturacionListado[i].desPropietarioVehBackup = facturacionListado[i].desPropietarioVeh;
            facturacionListado[i].codPropietarioVeh = null;
            facturacionListado[i].desPropietarioVeh = null;
            this.setState({ facturacionListado });
            this.setState({ arrayLibresPedidosPropietario: [] });
          }
        }

        break;
      case 3:

        for (let i = 0; i < facturacionListado.length; i++) {
          if (facturacionListado[i].numPedidoVeh === value) {
            facturacionListado[i].codUsuarioVehBackup = facturacionListado[i].codUsuarioVeh;
            facturacionListado[i].desUsuarioVeh = facturacionListado[i].desUsuarioVeh;
            facturacionListado[i].codUsuarioVeh = null;
            facturacionListado[i].desUsuarioVeh = null;
            this.setState({ facturacionListado });
            this.setState({ arrayLibresPedidosUsuario: [] });
          }
        }
        break;
      default:
        break;
    }
  }

  eliminarPedidoFacturacion = (tipo, divId, idUsuario, id) => {

    switch (tipo) {
      case 1:
        const listCodFacturacion = this.state.listCodFacturacion;

        for (let i = 0; i < this.state.facturacionListado.length; i++) {
          if (this.state.facturacionListado[i].codClie === idUsuario) {
            this.addPedidosfacturacionListado(this.state.facturacionListado[i].numPedidoVeh, tipo);
          }
        }
        for (let i = 0; i < this.state.listCodFacturacion.length; i++) {
          if (this.state.listCodFacturacion[i].id === idUsuario) {
            listCodFacturacion[i].statusEliminado = -1;
          }
        }

        this.setState({ listCodFacturacion });

        break;
      case 2:

        const listCodPropietario = this.state.listCodPropietario;

        for (let i = 0; i < this.state.facturacionListado.length; i++) {
          if (this.state.facturacionListado[i].codPropietarioVeh === idUsuario) {
            this.addPedidosfacturacionListado(this.state.facturacionListado[i].numPedidoVeh, tipo);
          }
        }
        for (let i = 0; i < this.state.listCodPropietario.length; i++) {
          if (this.state.listCodPropietario[i].id === idUsuario) {
            listCodPropietario[i].statusEliminado = -1;
          }
        }

        this.setState({ listCodPropietario });
        break;
      case 3:
        const listCodUsuario = this.state.listCodUsuario;
        for (let i = 0; i < this.state.facturacionListado.length; i++) {
          if (this.state.facturacionListado[i].codUsuarioVeh === idUsuario) {
            this.addPedidosfacturacionListado(this.state.facturacionListado[i].numPedidoVeh, tipo);
          }
        }
        for (let i = 0; i < this.state.listCodUsuario.length; i++) {
          if (this.state.listCodUsuario[i].id === idUsuario) {
            listCodUsuario[i].statusEliminado = -1;
          }
        }

        this.setState({ listCodUsuario });
        break;
      default:
        break;
    }


    document.getElementById(divId).innerHTML = '';
  }

  searchClientesPedidos = (option, value) => {

    this.props.loading('block');
    this.setState({ valueSerach: value });
    this.setState({ optionSearch: option });

    this.props.fetchClientesPedidos(option, value).then((result) => {
      this.props.loading('');
    }).catch((error) => {
      console.log(error);
    });
    return true;
  }

  editarUsuPedido = (usuarioNew, usuarioOld, idDiv, collapse, opcionDivPedidoUsuario, checked, id) => {
    let arreglo = [];
    const facturacionListado = this.state.facturacionListado;
    switch (idDiv[0]) {
      case 'F':
        arreglo = this.state.listCodFacturacion;
        arreglo[id].id = usuarioNew.codigo;
        arreglo[id].descripcion = usuarioNew.nombre;
        for (let i = 0; i < facturacionListado.length; i++) {
          if (facturacionListado[i].codClie === usuarioOld) {
            facturacionListado[i].codClie = usuarioNew.codigo;
            facturacionListado[i].desClie = usuarioNew.nombre;
            facturacionListado[i].codClieBackup = null;
            facturacionListado[i].desClieBackup = null;
          }
        }
        this.setState({ listCodFacturacion: arreglo });
        break;
      case 'P':
        arreglo = this.state.listCodPropietario;
        arreglo[id].id = usuarioNew.codigo;
        arreglo[id].descripcion = usuarioNew.nombre;

        for (let i = 0; i < facturacionListado.length; i++) {
          if (facturacionListado[i].codPropietarioVeh === usuarioOld) {
            facturacionListado[i].codPropietarioVeh = usuarioNew.codigo;
            facturacionListado[i].desPropietarioVeh = usuarioNew.nombre;
            facturacionListado[i].codPropietarioVehBackup = null;
            facturacionListado[i].desPropietarioVehBackup = null;
          }
        }

        this.setState({ listCodPropietario: arreglo });
        break;
      case 'U':
        arreglo = this.state.listCodUsuario;
        arreglo[id].id = usuarioNew.codigo;
        arreglo[id].descripcion = usuarioNew.nombre;

        for (let i = 0; i < this.state.facturacionListado.length; i++) {
          if (facturacionListado[i].codUsuarioVeh === usuarioOld) {
            facturacionListado[i].codUsuarioVeh = usuarioNew.codigo;
            facturacionListado[i].desUsuarioVeh = usuarioNew.nombre;
            facturacionListado[i].codUsuarioVehBackup = null;
            facturacionListado[i].desUsuarioVehBackup = null;
          }
        }
        this.setState({ listCodUsuario: arreglo });
        break;
      default: break;
    }
    this.setState({ facturacionListado });
    document.getElementById(idDiv).className = 'collapse';

    if (!document.getElementById(checked).checked) {
      this.renderFunHidePedFact(idDiv, collapse, opcionDivPedidoUsuario, null, null, null);
    }
  }

  agregarPedidosFacturacion =(id) => {
    let numPedidos = 0;
    switch (id) {

      case 1:

        this.state.facturacionListado.map(pedidos => (
          pedidos.codClie === null ? numPedidos++ : null
        ));

        if (numPedidos > 0) {
          this.state.listCodFacturacion.push({ id: (this.state.listCodFacturacion.length + 1) * -1, descripcion: '', checked1: false, checked2: true });
          this.setState({ listCodFacturacion: this.state.listCodFacturacion });
        } else {
          this.openAlertFacturacion({mensaje:'No Hay Pedidos que se puedan asignar para el cliente facturacion.',estadoTrama:'0'})
        }

        break;
      case 2:
        this.state.facturacionListado.map(pedidos => (
          pedidos.codPropietarioVeh === null ? numPedidos++ : null
        ));
        if (numPedidos > 0) {
          this.state.listCodPropietario.push({ id: (this.state.listCodPropietario.length + 1) * -1, descripcion: '', checked1: false, checked2: true });
          this.setState({ listCodPropietario: this.state.listCodPropietario });
        } else {
          this.openAlertFacturacion({mensaje:'No Hay Pedidos que se puedan asignar para el cliente propietario.',estadoTrama:'0'})
        }
        break;
      case 3:
        this.state.facturacionListado.map(pedidos => (
          pedidos.codUsuarioVeh === null ? numPedidos++ : null
        ));
        if (numPedidos > 0) {
          this.state.listCodUsuario.push({ id: (this.state.listCodUsuario.length + 1) * -1, descripcion: '', checked1: false, checked2: true });
          this.setState({ listCodUsuario: this.state.listCodUsuario });
        } else {
          this.openAlertFacturacion({mensaje:'No Hay Pedidos que se puedan asignar para el cliente usuario.',estadoTrama:'0'})
        }
        break;
      default:
        break;
    }
  }

  selectListPedDisponibles = (e, cod, codFacturacion, tipo) => {

    let i = 0;
    const facturacionListado = this.state.facturacionListado;
    switch (tipo) {
      case '1':
        if (this.state.arrayLibresPedidos.indexOf(cod) > -1) {
          const i = this.state.arrayLibresPedidos.indexOf(cod);
          this.state.arrayLibresPedidos.splice(i, 1);
          this.setState({ arrayLibresPedidos: this.state.arrayLibresPedidos });
        } else {
          this.state.arrayLibresPedidos.push(cod);
          const arreglo = this.state.arrayLibresPedidos;
          this.setState({ arrayLibresPedidos: arreglo });
          for (i = 0; i < facturacionListado.length; i++) {
            if (facturacionListado[i].numPedidoVeh === cod) {
              facturacionListado[i].codClie = codFacturacion;
            }
          }
        }
        break;
      case '2':
        if (this.state.arrayLibresPedidosPropietario.indexOf(cod) > -1) {
          const i = this.state.arrayLibresPedidosPropietario.indexOf(cod);
          this.state.arrayLibresPedidosPropietario.splice(i, 1);
          this.setState({ arrayLibresPedidosPropietario: this.state.arrayLibresPedidosPropietario });
        } else {
          this.state.arrayLibresPedidosPropietario.push(cod);
          const arreglo = this.state.arrayLibresPedidosPropietario;
          this.setState({ arrayLibresPedidosPropietario: arreglo });
          for (i = 0; i < facturacionListado.length; i++) {
            if (facturacionListado[i].numPedidoVeh === cod) {
              facturacionListado[i].codPropietarioVeh = codFacturacion;
            }
          }
        }

        break;
      case '3':
        if (this.state.arrayLibresPedidosUsuario.indexOf(cod) > -1) {
          const i = this.state.arrayLibresPedidosUsuario.indexOf(cod);
          this.state.arrayLibresPedidosUsuario.splice(i, 1);
          this.setState({ arrayLibresPedidosUsuario: this.state.arrayLibresPedidosUsuario });
        } else {
          this.state.arrayLibresPedidosUsuario.push(cod);
          const arreglo = this.state.arrayLibresPedidosUsuario;
          this.setState({ arrayLibresPedidosUsuario: arreglo });
          for (i = 0; i < facturacionListado.length; i++) {
            if (facturacionListado[i].numPedidoVeh === cod) {
              facturacionListado[i].codUsuarioVeh = codFacturacion;
            }
          }
        }
        break;
      default: break;
    }

    this.setState({ facturacionListado });
  }


  fnListadoPedidosFacturacion = (id) => {

      this.props.loading('block');

      const promises = [];
      this.setState({ idFichaVenta: id });
      this.props.fetchFichaVenta(id);

      promises.push(this.props.fetchFacturacion(id, TIPO_CONSULTA_AGRUPADO_X_FACTURACION_MULTIPLE, CON_PAGINACION, PAGINA, NUMERO_PAGINAS));
      promises.push(this.props.fetchFacturacion(id, TIPO_CONSULTA_AGRUPADO_X_FACTURACION_LISTADO_TOTAL, CON_PAGINACION, VACIO, VACIO));
      promises.push(this.props.fetchClientes(CONSULTA_CLIENTES, CONSULTA_TIPO));
      promises.push(this.props.fetchFacturacion(id, TIPO_CONSULTA_AGRUPADO_X_FACTURACION_CLIENTE, SIN_PAGINACION, PAGINA, NUMERO_PAGINAS))
      promises.push(this.props.fetchProformas(id));

      this.traerFacturacion(id);
      Promise.all(promises)
      .then((results) => {

        const idsProformas = results[4].payload.data.proformaExistenteList.map(row => row.numProfVeh);
        let pedidoDisponibles = [];


        getPedidosFechas(id, idsProformas).then((result) => {
                      idsProformas.forEach(numProfVeh => {
                        pedidoDisponibles = pedidoDisponibles.concat(_.filter(result, _.property(numProfVeh))[0][numProfVeh].map(entry => {return {numPedidoVeh:entry.numPedidoVeh,estadoPedido:entry.estadoPedido}}));

                  pedidoDisponibles = pedidoDisponibles.map(entry => entry.numPedidoVeh)
                  pedidoDisponibles = results[1].payload.data.listado.filter(entry => pedidoDisponibles.indexOf(entry.numPedidoVeh)>=0)

                  if(this.props.pedidosConCheck!==undefined){
                    pedidoDisponibles = pedidoDisponibles.filter(entry => this.props.pedidosConCheck.indexOf(entry.numPedidoVeh)>=0 )
                  }

                    this.setState({
                      facturacionGrupo: results[0].payload.data.listado,
                      facturacionListado: pedidoDisponibles,
                      cantidadListadoFacturacion: results[0].payload.data.cantidad,
                      listClientes: results[2].payload.data,
                      facturacionListadoModal: results[3].payload.data.listado,
                    });

                    this.state.facturacionListado.forEach((date) => {
                       const { listCodFacturacion, listCodPropietario, listCodUsuario } = this.state;
                       let { pedClieCount, pedPropCount, pedFactCount } = this.state;
                       listCodFacturacion.push({ id: date.codClie, descripcion: date.desClie });
                       listCodPropietario.push({ id: date.codPropietarioVeh, descripcion: date.desPropietarioVeh });
                       listCodUsuario.push({ id: date.codUsuarioVeh, descripcion: date.desUsuarioVeh });

                       this.setState({
                         listCodFacturacion: this.deleteDuplicate(listCodFacturacion, 'id'),
                         listCodPropietario: this.deleteDuplicate(listCodPropietario, 'id'),
                         listCodUsuario: this.deleteDuplicate(listCodUsuario, 'id'),
                         pedClieCount: date.numPedidoVeh !== null ? pedClieCount++ : null,
                         pedPropCount: date.numPedidoVeh !== null ? pedPropCount++ : null,
                         pedFactCount: date.numPedidoVeh !== null ? pedFactCount++ : null,
                       });

                     });
                     this.props.loading('');

                   this.setState({ pedidosConCheck: [] });
           })
         })
      });

    }

    renderFunHideClienFact(id, opcionPedidoUsuario) {
      if (document.getElementById(id).className === 'collapse in') {
        document.getElementById(id).className = 'collapse';
      } else {
        document.getElementById(id).className = 'collapse in';
      }
      document.getElementById(opcionPedidoUsuario).className = 'collapse';
    }

    renderFunHidePedFact(className, collapse, opcionDivPedidoUsuario, codigoUsuario, tipoCombo, id) {
      document.getElementById(opcionDivPedidoUsuario).className = collapse;
      document.getElementById(className).className = 'collapse';
      const facturacionListado = this.state.facturacionListado;
      const listCodFacturacion = this.state.listCodFacturacion;
      const listCodPropietario = this.state.listCodPropietario;
      const listCodUsuario = this.state.listCodUsuario;

      if (codigoUsuario !== null) {
        switch (tipoCombo[0]) {
          case 'F':

            if (tipoCombo.indexOf('CheckedDos') < 0) {
              for (let i = 0; i < facturacionListado.length; i++) {
                if (facturacionListado[i].codClie == null) {
                  facturacionListado[i].opcionPedido = 1;
                  facturacionListado[i].codClie = codigoUsuario;
                }
              }
              listCodFacturacion[id].checked1 = true;
              listCodFacturacion[id].checked2 = false;
            } else {
              for (let i = 0; i < facturacionListado.length; i++) {
                if (facturacionListado[i].codClie === codigoUsuario && facturacionListado[i].opcionPedido === 1) {
                  facturacionListado[i].opcionPedido = 0;
                  facturacionListado[i].codClie = null;
                }
              }
              listCodFacturacion[id].checked1 = false;
              listCodFacturacion[id].checked2 = true;
            }

            this.setState({ listPedidos: [] });
            this.setState({ facturacionListado });
            this.setState({ listCodFacturacion });
            break;
          case 'P':

            if (tipoCombo.indexOf('CheckedDos') < 0) {
              for (let i = 0; i < facturacionListado.length; i++) {
                if (facturacionListado[i].codPropietarioVeh == null) {
                  facturacionListado[i].opcionPedido = 1;
                  facturacionListado[i].codPropietarioVeh = codigoUsuario;
                }
              }
              listCodPropietario[id].checked1 = true;
              listCodPropietario[id].checked2 = false;
            } else {
              for (let i = 0; i < facturacionListado.length; i++) {
                if (facturacionListado[i].codPropietarioVeh === codigoUsuario && facturacionListado[i].opcionPedido === 1) {
                  facturacionListado[i].opcionPedido = 0;
                  facturacionListado[i].codPropietarioVeh = null;
                  this.setState({ listPedidos: [] });
                }
              }
              listCodPropietario[id].checked1 = false;
              listCodPropietario[id].checked2 = true;
            }
            this.setState({ facturacionListado });
            this.setState({ listCodPropietario });
            this.setState({ listPedidos: [] });
            break;
          case 'U':
            if (tipoCombo.indexOf('CheckedDos') < 0) {
              for (let i = 0; i < facturacionListado.length; i++) {
                if (facturacionListado[i].codUsuarioVeh == null) {
                  facturacionListado[i].opcionPedido = 1;
                  facturacionListado[i].codUsuarioVeh = codigoUsuario;
                }
              }
              listCodUsuario[id].checked1 = true;
              listCodUsuario[id].checked2 = false;
            } else {
              for (let i = 0; i < facturacionListado.length; i++) {
                if (facturacionListado[i].codUsuarioVeh === codigoUsuario && facturacionListado[i].opcionPedido === 1) {
                  facturacionListado[i].opcionPedido = 0;
                  facturacionListado[i].codUsuarioVeh = null;
                }
              }
              listCodUsuario[id].checked1 = false;
              listCodUsuario[id].checked2 = true;
            }
            this.setState({ facturacionListado });
            this.setState({ listCodUsuario });
            this.setState({ listPedidos: [] });

            break;
          default:
            break;
        }
      }
    }

    deleteDuplicate(arr, prop) {
      const nuevoArray = [];
      const lookup = {};

      for (var i in arr) {
        lookup[arr[i][prop]] = arr[i];
      }

      for (i in lookup) {
        lookup[i].checked1 = false;
        lookup[i].checked2 = true;
        nuevoArray.push(lookup[i]);
      }

      return nuevoArray;
    }

    traerFacturacion = (idFichaVenta) =>{



      this.props.fetchFacturacion(idFichaVenta, TIPO_CONSULTA_AGRUPADO_X_FACTURACION_CLIENTE, SIN_PAGINACION, PAGINA, NUMERO_PAGINAS)
      .then((result) => {
        if (result.payload.data.estadoTrama === '1') {
          const ped = result.payload.data.listado
          .filter(element => element.numPedidoVeh.split(' ').filter(z => this.state.pedidosConCheck.filter(y => y === z).length !== 0).length !== 0);
          this.setState({
            pedidosClienteFacturacion: ped.map((row) => {
              const numPedidos = row.numPedidoVeh.split(' ').filter(z => this.state.pedidosConCheck.filter(y => y === z).length !== 0);
              return {
                'numPedidoVeh': numPedidos,
                'codClie': row.codClie,
                'desClie': row.desClie,
                'rucClie': row.rucClie,
                'dniClie': row.dniClie,
                'desFormPago': row.desFormPago,
                'desPropietarioVeh': row.desPropietarioVeh,
                'desTipoDoc': row.desTipoDoc,
                'desUsuarioVeh': row.desUsuarioVeh,
                'entidadFinancieraProf': row.entidadFinancieraProf,
                'nomUsuarioSolFact': row.nomUsuarioSolFact,
                'tipoSolFact': row.tipoSolFact,
                'codProv': row.codProv,
                'codCIA': row.codCIA,
                'numProfVeh':row.numProfVeh,
                'estadoTransitoFact':row.estadoTransitoFact
              };
            })
          });

        }
      }).catch(error => console.log(error));
    }

  render() {
      return(
        <div>
            <Modal title='Editar cliente' idModal='fdv-solExcep' closeModal={this.props.closeModal} isOpen action={this.props.action} modalSize='modal-dialog modal-lg'>
              {this.state.listCodFacturacion.map((listCodFacturacion, id) => (
                listCodFacturacion.id != null ? (
                  <div className='form-group' key={`F-Div${listCodFacturacion.id}`} id={`F-Div${listCodFacturacion.id}`} >
                    <div style={{ marginBottom: '-6px', marginTop: '20px' }} className='card card-lg card-plain mb-2'>
                      <p className='labelInfo'>Cliente de facturación</p>
                      <div className='cd-cont'>
                        <div className='row'>
                          <div className='col-md-10'>
                            {listCodFacturacion.id < 0 ? null :
                              (<p>{listCodFacturacion.id} - {listCodFacturacion.descripcion}</p>)
                            }
                          </div>
                          <div className='col-md-2'>
                            <button className='btn-clean' show='#EdCtablaAsignar3' onClick={() => this.renderFunHideClienFact(`F-listUsuFac${listCodFacturacion.id}`, `F-EdCapp${listCodFacturacion.id}`)} hideparent='.cd-cont'><i className='ion-edit c-cyan h6 mr-2' /></button>
                            {id > 0 ? (
                              <button className='btn-clean h6 c-cyan' onClick={() => this.eliminarPedidoFacturacion(1, `F-Div${listCodFacturacion.id}`, listCodFacturacion.id, listCodFacturacion.id)} ><i className='ion-trash-a' /></button>
                              ) : null}
                          </div>
                          <div className='col-xs-12'>
                            <div className='radio'>
                              <label className='radio-label'>
                                <input checked={listCodFacturacion.checked1} type='radio' name={`F-EdCappl2${id}`} id={`F-Checked${listCodFacturacion.id}`} onClick={() => this.renderFunHidePedFact(`F-listUsuFac${listCodFacturacion.id}`, 'collapse', `F-EdCapp${listCodFacturacion.id}`, listCodFacturacion.id, `F-Checked${listCodFacturacion.id}`, id)} />
                                <div className='radio-skin' />Aplicar a todos los pedidos</label>
                            </div>
                            <div className='radio'>
                              <label className='radio-label'>
                                <input checked={listCodFacturacion.checked2} type='radio' name={`F-EdCappl2${id}`} id={`F-CheckedDos${listCodFacturacion.id}`} onClick={() => this.renderFunHidePedFact(`F-listUsuFac${listCodFacturacion.id}`, 'collapse in', `F-EdCapp${listCodFacturacion.id}`, listCodFacturacion.id, `F-CheckedDos${listCodFacturacion.id}`, id)} />
                                <div className='radio-skin' />Aplicar a los pedidos seleccionados</label>
                            </div>
                          </div>
                        </div>

                        <div className='row collapse in' id={`F-EdCapp${listCodFacturacion.id}`}>
                          <div className='col-sm-6'>
                            <div className='dropdown dropdown-multi customToggle' id='agrupacion'>
                              <div className='dropdown-control'>
                                <input className='dropdown-control-input' placeholder='Seleccione pedidos' />
                                <div className='dropdown-control-icon'><i className='ion-arrow-down-b' /></div>
                              </div>
                              <div className='dropdown-tooltip dropdown-menu'>
                                <div className='dropdown-scroll'>
                                  <ul>
                                    {this.state.facturacionListado.map(facturacionListado => (
                                        facturacionListado.codClie === null ? (
                                          <li>
                                            <CustomCheckbox
                                              selectListPedDisponibles={this.selectListPedDisponibles}
                                              cod={facturacionListado.numPedidoVeh}
                                              listPedidos={this.state.arrayLibresPedidos}
                                              name={facturacionListado.numPedidoVeh}
                                              codFacturacion={listCodFacturacion.id}
                                              tipo='1'
                                            />
                                          </li>
                                          ) : null
                                    ))}
                                  </ul>
                                </div>
                              </div>
                            </div>
                            <div className='col-xs-12'>
                              <div className='pillSelct mb-3'>
                                <ul className='pillSelct-pills'>
                                  {this.state.facturacionListado.map(facturacionListado => (
                                    facturacionListado.codClie === listCodFacturacion.id ? (
                                      <li className='pillSelct-pills-item pill pill-cyan'>{facturacionListado.numPedidoVeh}
                                        <button className='pillSelct-delete'>
                                          <i className='icon ion-close pill-close' onClick={() => this.addPedidosfacturacionListado(facturacionListado.numPedidoVeh, 1)} />
                                        </button>
                                      </li>
                                      ) : null
                                  ))}
                                </ul>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className='tableSearch collapse' id={`F-listUsuFac${listCodFacturacion.id}`}>
                          <hr />
                          <div className='row'>
                            <div className='col-md-6 mb-3 mt-2'>
                              <div className='fSearch'>
                                <div className='fSearch-filter form-control'>
                                  <select
                                    value={this.searchOption}
                                    onChange={this.onChangeInput}
                                    className='searchOption'
                                    name='searchOption'
                                  >
                                    <option value='cadena'>Cliente</option>
                                    <option value='dni'>DNI</option>
                                    <option value='ruc'>RUC</option>
                                  </select>
                                </div>
                                <input
                                  type='text'
                                  className='fSearch-search form-control'
                                  placeholder='Ingrese el dato seleccionado'
                                  name='clientInput'
                                  value={this.state.clientInput}
                                  onChange={this.onChangeInput}
                                  onKeyPress={(e) => {
                                    if (e.key === 'Enter') {
                                      e.preventDefault();
                                      this.searchClientesPedidos(this.state.searchOption, this.state.clientInput);
                                    }
                                  }}
                                />
                                <button className='btn btn-dark fSearch-go' onClick={() => this.searchClientesPedidos(this.state.searchOption, this.state.clientInput)}><i className='ion-android-arrow-forward' /></button>
                              </div>
                            </div>
                          </div>
                          <div className='pillSelct'>
                            <p className='pillSelct-label labelInfo'><span>Has seleccionado</span><span> 2/3</span><span>vehículos</span></p>
                          </div>
                          <ul className='pillSelct-pills' />
                          <div className='hidden-xs'>
                            <div className='tableWrapper'>
                              <table className='table table-hover'>
                                <thead className='table-head'>
                                  <tr>
                                    <th>Código</th>
                                    <th>Nombre</th>
                                    <th>RUC</th>
                                    <th>DNI</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {
                                     this.props.clientes
                                      ? renderTable(this.props.clientes, this.editarUsuPedido, `F-listUsuFac${listCodFacturacion.id}`, listCodFacturacion.id, 'collapse in', `F-EdCapp${listCodFacturacion.id}`, `F-Checked${listCodFacturacion.id}`, id)
                                      : null
                                   }
                                </tbody>
                              </table>

                            </div>

                            <div className={this.props.clientes.numerodePaginas > 1 ? 'paginationWrapper' : 'hidden'}>
                              <div className='row'>

                                <div className='col-sm-6 pull-right'>
                                  <ReactPaginate
                                    pageCount={5}
                                    onPageChange={this.handlePageClick}
                                    previousLabel='<<'
                                    nextLabel='>>'
                                    containerClassName='pagination pull-right'
                                    pageClassName='pagination-item'
                                    activeClassName='pagination-item--active'
                                    pageLinkClassName='btn-clean pagination-item-btn'
                                    breakClassName='break pagination-item'
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : null
              ))}
              <button className='btn btn-iconLeft btn-link' show='.id65 in .id64'><i className='ion-plus' /><span onClick={() => this.agregarPedidosFacturacion(1)}>Agregar cliente de facturación</span></button>

              {this.state.disabledClientePropietario===true?null:(
                this.state.listCodPropietario.map((listCodPropietario, id) => (
                 listCodPropietario.id != null ? (
                   <div className='form-group' id={`P-Div${listCodPropietario.id}`} key={`P-Div${listCodPropietario.id}`} >
                     <div style={{ marginBottom: '-6px', marginTop: '20px' }} className='card card-lg card-plain mb-2'>
                       <p className='labelInfo'>Cliente de Propietario</p>
                       <div className='cd-cont'>
                         <div className='row'>
                           <div className='col-md-10'>
                             {listCodPropietario.id < 0 ? null : (
                               <p>{listCodPropietario.id} - {listCodPropietario.descripcion}</p>
                                        )
                                      }

                           </div>
                           <div className='col-md-2'>
                             <button className='btn-clean' show='#EdCtablaAsignar3' onClick={() => this.renderFunHideClienFact(`P-listUsuPro${listCodPropietario.id}`, `P-EdCapp${listCodPropietario.id}`)} hideparent='.cd-cont'><i className='ion-edit c-cyan h6 mr-2' /></button>
                             {id > 0 ? (
                               <button className='btn-clean h6 c-cyan' onClick={() => this.eliminarPedidoFacturacion(2, `P-Div${listCodPropietario.id}`, listCodPropietario.id, id)}><i className='ion-trash-a' /></button>
                                      ) : null}
                           </div>
                           <div className='col-xs-12'>
                             <div className='radio'>
                               <label className='radio-label'>
                                 <input checked={listCodPropietario.checked1} type='radio' name={`P-EdCappl2${id}`} id={`P-Checked${listCodPropietario.id}`} onClick={() => this.renderFunHidePedFact(`P-listUsuPro${listCodPropietario.id}`, 'collapse', `P-EdCapp${listCodPropietario.id}`, listCodPropietario.id, `P-Checked${listCodPropietario.id}`, id)} />
                                 <div className='radio-skin' />Aplicar a todos los pedidos
                                            </label>
                             </div>
                             <div className='radio'>
                               <label className='radio-label'>
                                 <input checked={listCodPropietario.checked2} type='radio' name={`P-EdCappl2${id}`} id={`P-CheckedDos${listCodPropietario.id}`} onClick={() => this.renderFunHidePedFact(`P-listUsuPro${listCodPropietario.id}`, 'collapse in', `P-EdCapp${listCodPropietario.id}`, listCodPropietario.id, `P-CheckedDos${listCodPropietario.id}`, id)} />
                                 <div className='radio-skin' />Aplicar a los pedidos seleccionados
                                            </label>
                             </div>
                           </div>
                         </div>

                         <div className='row collapse in' id={`P-EdCapp${listCodPropietario.id}`}>
                           <div className='col-sm-6'>
                             <div className='dropdown dropdown-multi customToggle' id='agrupacion'>
                               <div className='dropdown-control'>
                                 <input className='dropdown-control-input' placeholder='Seleccione pedidos' />
                                 <div className='dropdown-control-icon'><i className='ion-arrow-down-b' /></div>
                               </div>
                               <div className='dropdown-tooltip dropdown-menu'>
                                 <div className='dropdown-scroll'>
                                   <ul>
                                     {this.state.facturacionListado.map(facturacionListado => (
                                        facturacionListado.codPropietarioVeh === null ? (
                                          <li>
                                            <CustomCheckbox
                                              selectListPedDisponibles={this.selectListPedDisponibles}
                                              cod={facturacionListado.numPedidoVeh}
                                              listPedidos={this.state.arrayLibresPedidosPropietario}
                                              name={facturacionListado.numPedidoVeh}
                                              codFacturacion={listCodPropietario.id}
                                              tipo='2'
                                            />
                                          </li>
                                          ) : null
                                      ))}
                                   </ul>
                                 </div>
                               </div>
                             </div>
                             <div className='col-xs-12'>
                               <div className='pillSelct mb-3'>
                                 <ul className='pillSelct-pills'>
                                   {this.state.facturacionListado.map(facturacionListado => (
                                      facturacionListado.codPropietarioVeh === listCodPropietario.id ? (
                                        <li className='pillSelct-pills-item pill pill-cyan'>{facturacionListado.numPedidoVeh}
                                          <button className='pillSelct-delete'>
                                            <i className='icon ion-close pill-close' onClick={() => this.addPedidosfacturacionListado(facturacionListado.numPedidoVeh, 2)} />
                                          </button>
                                        </li>
                                        ) : null
                                    ))}
                                 </ul>
                               </div>
                             </div>
                           </div>
                         </div>

                         <div className='tableSearch collapse' id={`P-listUsuPro${listCodPropietario.id}`}>
                           <hr />
                           <div className='row'>
                             <div className='col-md-6 mb-3 mt-2'>
                               <div className='fSearch'>
                                 <div className='fSearch-filter form-control'>
                                   <select
                                     value={this.props.searchOption}
                                     onChange={this.onChangeInput}
                                     className='searchOption'
                                     name='searchOption'
                                   >
                                     <option value='cadena'>Cliente</option>
                                     <option value='dni'>DNI</option>
                                     <option value='ruc'>RUC</option>
                                   </select>
                                 </div>
                                 <input
                                   type='text'
                                   className='fSearch-search form-control'
                                   placeholder='Ingrese el dato seleccionado'
                                   name='clientInput'
                                   value={this.state.clientInput}
                                   onChange={this.onChangeInput}
                                   onKeyPress={(e) => {
                                     if (e.key === 'Enter') {
                                       e.preventDefault();
                                       this.searchClientesPedidos(this.state.searchOption, this.state.clientInput);
                                     }
                                   }}
                                 />
                                 <button className='btn btn-dark fSearch-go' onClick={() => this.searchClientesPedidos(this.state.searchOption, this.state.clientInput)}><i className='ion-android-arrow-forward' /></button>
                               </div>
                             </div>
                           </div>
                           <div className='pillSelct'>
                             <p className='pillSelct-label labelInfo'><span>Has seleccionado</span><span> 2/3</span><span>vehículos</span></p>
                           </div>
                           <ul className='pillSelct-pills' />
                           <div className='hidden-xs'>
                             <div className='tableWrapper'>
                               <table className='table table-hover'>
                                 <thead className='table-head'>
                                   <tr>
                                     <th>Código</th>
                                     <th>Nombre</th>
                                     <th>RUC</th>
                                     <th>DNI</th>
                                   </tr>
                                 </thead>
                                 <tbody>
                                   {
                                     this.props.clientes
                                      ? renderTable(this.props.clientes, this.editarUsuPedido, `P-listUsuPro${listCodPropietario.id}`, listCodPropietario.id, 'collapse in', `P-EdCapp${listCodPropietario.id}`, `P-Checked${listCodPropietario.id}`, id)
                                      : null
                                   }
                                 </tbody>
                               </table>

                             </div>

                             <div className={this.props.clientes.numerodePaginas > 1 ? 'paginationWrapper' : 'hidden'}>
                               <div className='row'>
                                 {/* <div className='col-sm-6'>
                                       Estás viendo {this.this.props.clientes.data.length}
                                       de {this.this.props.clientes.cantidad} clientes
                                     </div> */}
                                 <div className='col-sm-6 pull-right'>
                                   <ReactPaginate
                                     pageCount={5}
                                     onPageChange={this.handlePageClick}
                                     previousLabel='<<'
                                     nextLabel='>>'
                                     containerClassName='pagination pull-right'
                                     pageClassName='pagination-item'
                                     activeClassName='pagination-item--active'
                                     pageLinkClassName='btn-clean pagination-item-btn'
                                     breakClassName='break pagination-item'
                                   />
                                 </div>
                               </div>
                             </div>
                           </div>
                         </div>
                       </div>
                     </div>
                   </div>
                    ) : null
                )))}
              {this.state.disabledClientePropietario===true?null:(
              <button className='btn btn-iconLeft btn-link' show='.id65 in .id64'><i className='ion-plus' /><span onClick={() => this.agregarPedidosFacturacion(2)} >Agregar cliente de Propietario</span></button>
              )}
              {this.state.listCodUsuario.map((listCodUsuario, id) => (
                  listCodUsuario.id != null ? (

                    <div className='form-group' key={`U-Div${listCodUsuario.id}`} id={`U-Div${listCodUsuario.id}`}>
                      <div style={{ marginBottom: '-6px', marginTop: '20px' }} className='card card-lg card-plain mb-2'>
                        <p className='labelInfo'>Cliente de Usuario</p>
                        <div className='cd-cont'>
                          <div className='row'>
                            <div className='col-md-10'>
                              {listCodUsuario.id < 0 ?
                                null : <p>{listCodUsuario.id} - {listCodUsuario.descripcion}</p>}
                            </div>
                            <div className='col-md-2'>
                              <button className='btn-clean' show='#EdCtablaAsignar3' onClick={() => this.renderFunHideClienFact(`U-listUsu${listCodUsuario.id}`, `U-EdCapp${listCodUsuario.id}`)} hideparent='.cd-cont'><i className='ion-edit c-cyan h6 mr-2' /></button>
                              {id > 0 ? (
                                <button className='btn-clean h6 c-cyan' onClick={() => this.eliminarPedidoFacturacion(3, `U-Div${listCodUsuario.id}`, listCodUsuario.id, id)}><i className='ion-trash-a' /></button>
                                   ) : null}
                            </div>
                            <div className='col-xs-12'>
                              <div className='radio'>
                                <label className='radio-label'>
                                  <input checked={listCodUsuario.checked1} type='radio' name={`U-EdCappl2${id}`} id={`U-Checked${listCodUsuario.id}`} onClick={() => this.renderFunHidePedFact(`U-listUsu${listCodUsuario.id}`, 'collapse', `U-EdCapp${listCodUsuario.id}`, listCodUsuario.id, `U-Checked${listCodUsuario.id}`, id)} />
                                  <div className='radio-skin' />Aplicar a todos los pedidos
                                         </label>
                              </div>
                              <div className='radio'>
                                <label className='radio-label'>
                                  <input checked={listCodUsuario.checked2} type='radio' name={`U-EdCappl2${id}`} id={`U-CheckedDos${listCodUsuario.id}`} onClick={() => this.renderFunHidePedFact(`U-listUsu${listCodUsuario.id}`, 'collapse in', `U-EdCapp${listCodUsuario.id}`, listCodUsuario.id, `U-CheckedDos${listCodUsuario.id}`, id)} />
                                  <div className='radio-skin' />Aplicar a los pedidos seleccionados
                                         </label>
                              </div>
                            </div>
                          </div>

                          <div className='row collapse in' id={`U-EdCapp${listCodUsuario.id}`}>
                            <div className='col-sm-6'>
                              <div className='dropdown dropdown-multi customToggle' id='agrupacion'>
                                <div className='dropdown-control'>
                                  <input className='dropdown-control-input' placeholder='Seleccione pedidos' />
                                  <div className='dropdown-control-icon'><i className='ion-arrow-down-b' /></div>
                                </div>
                                <div className='dropdown-tooltip dropdown-menu'>
                                  <div className='dropdown-scroll'>
                                    <ul>
                                      {this.state.facturacionListado.map((facturacionListado, id) => (
                                         facturacionListado.codUsuarioVeh === null ? (
                                           <li>
                                             <CustomCheckbox
                                               selectListPedDisponibles={this.selectListPedDisponibles}
                                               cod={facturacionListado.numPedidoVeh}
                                               listPedidos={this.state.arrayLibresPedidosUsuario}
                                               name={facturacionListado.numPedidoVeh}
                                               codFacturacion={listCodUsuario.id}
                                               tipo='3'
                                             />
                                           </li>
                                           ) : null
                                       ))}
                                    </ul>
                                  </div>
                                </div>
                              </div>
                              <div className='col-xs-12'>
                                <div className='pillSelct mb-3'>
                                  <ul className='pillSelct-pills'>
                                    {this.state.facturacionListado.map((facturacionListado, id) => (
                                       facturacionListado.codUsuarioVeh === listCodUsuario.id ? (
                                         <li className='pillSelct-pills-item pill pill-cyan'>{facturacionListado.numPedidoVeh}
                                           <button className='pillSelct-delete'>
                                             <i className='icon ion-close pill-close' onClick={() => this.addPedidosfacturacionListado(facturacionListado.numPedidoVeh, 3)} />
                                           </button>
                                         </li>
                                         ) : null
                                      ))}
                                  </ul>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className='tableSearch collapse' id={`U-listUsu${listCodUsuario.id}`}>
                            <hr />
                            <div className='row'>
                              <div className='col-md-6 mb-3 mt-2'>
                                <div className='fSearch'>
                                  <div className='fSearch-filter form-control'>
                                    <select
                                      value={this.state.searchOption}
                                      onChange={this.onChangeInput}
                                      className='searchOption'
                                      name='searchOption'
                                    >
                                      <option value='cadena'>Cliente</option>
                                      <option value='dni'>DNI</option>
                                      <option value='ruc'>RUC</option>
                                    </select>
                                  </div>
                                  <input
                                    type='text'
                                    className='fSearch-search form-control'
                                    placeholder='Ingrese el dato seleccionado'
                                    name='clientInput'
                                    value={this.state.clientInput}
                                    onChange={this.onChangeInput}
                                    onKeyPress={(e) => {
                                      if (e.key === 'Enter') {
                                        e.preventDefault();
                                        this.searchClientesPedidos(this.state.searchOption, this.state.clientInput);
                                      }
                                    }}
                                  />
                                  <button className='btn btn-dark fSearch-go' onClick={() => this.searchClientesPedidos(this.state.searchOption, this.state.clientInput)}><i className='ion-android-arrow-forward' /></button>
                                </div>
                              </div>
                            </div>
                            <div className='pillSelct'>
                              <p className='pillSelct-label labelInfo'><span>Has seleccionado</span><span> 2/3</span><span>vehículos</span></p>
                            </div>
                            <ul className='pillSelct-pills' />
                            <div className='hidden-xs'>
                              <div className='tableWrapper'>
                                <table className='table table-hover'>
                                  <thead className='table-head'>
                                    <tr>
                                      <th>Código</th>
                                      <th>Nombre</th>
                                      <th>RUC</th>
                                      <th>DNI</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {
                                    this.props.clientes
                                     ? renderTable(this.props.clientes, this.editarUsuPedido, `U-listUsu${listCodUsuario.id}`, listCodUsuario.id, 'collapse in', `U-EdCapp${listCodUsuario.id}`, `U-Checked${listCodUsuario.id}`, id)
                                     : null
                                  }
                                  </tbody>
                                </table>

                              </div>

                              <div className={this.props.clientes.numerodePaginas > 1 ? 'paginationWrapper' : 'hidden'}>
                                <div className='row'>
                                  <div className='col-sm-6 pull-right'>
                                    <ReactPaginate
                                      pageCount={5}
                                      onPageChange={this.handlePageClick}
                                      previousLabel='<<'
                                      nextLabel='>>'
                                      containerClassName='pagination pull-right'
                                      pageClassName='pagination-item'
                                      activeClassName='pagination-item--active'
                                      pageLinkClassName='btn-clean pagination-item-btn'
                                      breakClassName='break pagination-item'
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                 ) : null
             ))}
              <button className='btn btn-iconLeft btn-link' show='.id65 in .id64'><i className='ion-plus' /><span onClick={() => this.agregarPedidosFacturacion(3)}>Agregar cliente de Usuario</span></button>

              <div className='modal-actions'>
                <button className='btn btn-default' data-dismiss='modal' onClick={this.props.closeModal} data-toggle='modal' data-target='#fdv-detalle'>Volver</button>
                <button className='btn btn-primary pull-right' data-dismiss='modal' data-toggle='modal' data-target='#fdv-detalle' onClick={() => this.editarPedidosFacturacion()}>Editar datos</button>
              </div>



            </Modal>
            { this.state.alertErrorOpenModFacturacion &&
              <Alert type='alert-warning alertModal' icon='ion-alert-circled' closeAlert={this.closeAlertErrorModFacturacion}>
                <p>{this.state.alertErrorMessage}</p>
              </Alert>
            }

            {
              this.props.fichasVenta && this.props.fichasVenta.error ?
                <Alert type='alert-danger alertModal' icon='ion-alert-circled'>
                  <p>Hubo un error con el servicio de listar fichasVenta</p>
                </Alert> : null
            }

            {
              this.props.clientes && this.props.clientes.error ?
                <Alert type='alert-danger alertModal' icon='ion-alert-circled'>
                  <p>Hubo un error con el servicio de listar clientes</p>
                </Alert> : null
            }

        </div>
      )}


};



function mapStateToProps(state) {
  return {
    fichasVenta: state.fichasVenta,
    clientes: state.clientes,
  };
}

export default withRouter(
  connect(mapStateToProps, {
    fetchFacturacion, fetchClientes, fetchFichaVenta, fetchClientesPedidos, fetchEditarFacturacion, fetchProformas
  })(EditarFacturacion));



// WEBPACK FOOTER //
// ./src/pages/DetalleFichaVenta/TabViews/Facturacion/EditarFacturacion/index.js